import { render, staticRenderFns } from "./CardTarjaPapoDeSegundaV2.vue?vue&type=template&id=af4e7fb4&scoped=true"
import script from "./CardTarjaPapoDeSegundaV2.vue?vue&type=script&lang=js"
export * from "./CardTarjaPapoDeSegundaV2.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaPapoDeSegundaV2.vue?vue&type=style&index=0&id=af4e7fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4e7fb4",
  null
  
)

export default component.exports